import { render, staticRenderFns } from "./Libyana.vue?vue&type=template&id=b79ca6e0&"
import script from "./Libyana.vue?vue&type=script&lang=js&"
export * from "./Libyana.vue?vue&type=script&lang=js&"
import style0 from "./Libyana.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports